<div class="bg-surface-0 px-6 py-20 md:px-12 lg:px-20">
  <div
    class="text-center bg-[radial-gradient(50%_109137.91%_at_50%_50%,color-mix(in_srgb,_var(--p-primary-500)_10%,transparent)_0%,rgba(254,244,247,0)_100%)]"
  >
    <span class="bg-white text-primary font-bold text-2xl inline-block px-4"
      >404</span
    >
  </div>
  <div class="mt-12 mb-8 font-bold text-6xl text-surface-900 text-center">
    Page Not Found
  </div>
  <p class="text-surface-700 text-3xl mt-0 mb-12 text-center">
    Sorry, we couldn't find the page.
  </p>
  <div class="text-center">
    <p-button
      class="mr-2"
      label="Go Back Login"
      icon="pi pi-arrow-left"
      routerLink="/auth/login"
    ></p-button>
    <p-button
      label="Go to Dashboard"
      icon="pi pi-home"
      routerLink="/dashboard"
    ></p-button>
  </div>
</div>
